import { CapacitorBarcodeScanner, CapacitorBarcodeScannerOptions, CapacitorBarcodeScannerPlugin, CapacitorBarcodeScannerTypeHint } from '@capacitor/barcode-scanner';

import { Capacitor } from "@capacitor/core";
import { getDeviceInfo } from "./DeviceInfoPlugin";

// let barcodeScanner: CapacitorBarcodeScannerPlugin | undefined = undefined;
// if (!Capacitor.isPluginAvailable("CapacitorBarcodeScanner")) {
//     console.warn("CapacitorBarcodeScanner plugin is not available");
//      barcodeScanner = Capacitor.registerPlugin("CapacitorBarcodeScanner");
// } else {
//     barcodeScanner = (Capacitor as any).Plugins.CapacitorBarcodeScanner as CapacitorBarcodeScannerPlugin;
// }

// const barcodeScanner: CapacitorBarcodeScannerPlugin = Capacitor.registerPlugin("CapacitorBarcodeScanner");

export interface BarcodeScanResult {
    content?: string;
    type?: string;
    cancelled: boolean;
}

let useOld = false;

export function initializeBarcodeWrapper() {
    getDeviceInfo().then(x => {
        useOld = false;
    });
}

export async function scanBarcode(callback?: (content: BarcodeScanResult) => void): Promise<BarcodeScanResult> {
    const bcOptions : CapacitorBarcodeScannerOptions = { hint: CapacitorBarcodeScannerTypeHint.ALL };

    const result = await CapacitorBarcodeScanner.scanBarcode(bcOptions); // start scanning and wait for a result
    const res: BarcodeScanResult = {
        content: result.ScanResult,
        type: undefined,
        cancelled: false
    };
    if (!res.content) {
        res.cancelled = true;
    }
    // if the result has content
    if (result.ScanResult && callback) {
        callback(res);
    }
    return res;
}
